import React from "react";
import { Routes, Route } from "react-router-dom";
import Registre from "./pages/registre";
import RecuperarSenha from "./pages/recoverPassword";
import ResetarSenha from "./pages/resetPassword";
import ApprovedLogin from "./pages/approvedLogin";
import ApprovedAdminPanel from "./pages/approvedAdminPanel";


export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Registre />} />
      <Route path="/aprovedlogin" element={<ApprovedLogin />} />
      <Route path="/aproved" element={<ApprovedAdminPanel />} />
      <Route path="/recuperar-senha" element={<RecuperarSenha />} />
      <Route path="/reset-password" element={<ResetarSenha />} />
      <Route path="/resetar-senha" element={<ResetarSenha />} />
    </Routes>
  );
}
